module.exports = __webpack_public_path__ + "static/media/citrus_color_green.647f5b62.svg";